export const SUPERSCRIPT_CHARS_MAP: Readonly<Record<string, string>> = {
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  ᵃ: "a",
  ª: "a",
  ᵇ: "b",
  ᶜ: "c",
  ᵈ: "d",
  ᵉ: "e",
  ᶠ: "f",
  ᵍ: "g",
  ʰ: "h",
  ⁱ: "i",
  ʲ: "j",
  ᵏ: "k",
  ˡ: "l",
  ᵐ: "m",
  ⁿ: "n",
  ᵒ: "o",
  º: "o",
  ᵖ: "p",
  ʳ: "r",
  ˢ: "s",
  ᵗ: "t",
  ᵘ: "u",
  ᵛ: "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  ᶻ: "z",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
};

export const SUBSCRIPT_CHARS_MAP: Readonly<Record<string, string>> = {
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  ₐ: "a",
  ₑ: "e",
  ₒ: "o",
  ₓ: "x",
  ₕ: "h",
  ₖ: "k",
  ₗ: "l",
  ₘ: "m",
  ₙ: "n",
  ₚ: "p",
  ₛ: "s",
  ₜ: "t",
  "₊": "+",
  "₋": "-",
  "₌": "=",
};

export function normalizeUnicodeSubSup(text: string): string {
  const supKeys = Object.keys(SUPERSCRIPT_CHARS_MAP).join("");
  const subKeys = Object.keys(SUBSCRIPT_CHARS_MAP).join("");
  const pattern = new RegExp(`(\\^?[${supKeys}]+)|(_?[${subKeys}]+)`, "g");

  return text.replace(pattern, (match, supMatch?: string, subMatch?: string) => {
    if (supMatch !== undefined) {
      const chars = supMatch.startsWith("^") ? supMatch.slice(1) : supMatch;
      return `^{${Array.from(chars)
        .map((c) => SUPERSCRIPT_CHARS_MAP[c] ?? c)
        .join("")}}`;
    }

    if (subMatch !== undefined) {
      const chars = subMatch?.startsWith("_") ? subMatch.slice(1) : subMatch;
      return `_{${Array.from(chars)
        .map((c) => SUBSCRIPT_CHARS_MAP[c] ?? c)
        .join("")}}`;
    }

    return match;
  });
}

export function matchSubSupChar(
  value: string,
): { value: string; position: "top" | "bottom" } | undefined {
  const sup = SUPERSCRIPT_CHARS_MAP[value];
  const sub = SUBSCRIPT_CHARS_MAP[value];

  if (sup || sub) {
    return {
      value: sup || sub,
      position: sup ? "top" : "bottom",
    };
  }

  return undefined;
}
